<template>
  <div :class="{ 'success-page': saveStatus === 'success' }">
    <v-alert v-if="saveStatus === 'failure'" type="error">
      Speichern fehlgeschlagen! Bitte erneut versuchen.
    </v-alert>

    <div v-if="saveStatus === 'success'" class="success-container">
      <v-alert type="success" prominent>
        {{ $t("medkitlogs.saveSuccess") }}
      </v-alert>
    </div>

    <medkitlogQrCodeForm
      v-if="!formHidden"
      @saveSuccess="handleSaveSuccess"
      @saveFailure="handleSaveFailure"
    />
  </div>
</template>

<script>
import MedkitlogQrCodeForm from "./medkitlogQrCodeForm.vue";

export default {
  name: "medkitQrCode",
  components: { MedkitlogQrCodeForm },
  data() {
    return {
      saveStatus: null,
      formHidden: false,
    };
  },
  methods: {
    handleSaveSuccess() {
      this.saveStatus = "success";
      this.formHidden = true;

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleSaveFailure() {
      this.saveStatus = "failure";
      this.formHidden = false;
    },
  },
};
</script>

<style scoped>
.success-page {
  height: 100dvh;
  overflow: hidden;
}

.success-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
</style>
